
import {useEffect, useState } from 'react'

import { useWindowSize } from 'usehooks-ts'
import { Toaster } from "react-hot-toast";
import { Text,Flex, Image, Heading, Box, Button } from '@chakra-ui/react'

import MintButton from './components/MintButton'
import { useContractRead, useNetwork } from 'wagmi';
import AccountButton from './components/AccountButton/AccountButton';
import abi from "./abi/Ethm.json";

export default function App() {
  const { width } = useWindowSize()
  const [ supplyLeft, setSupplyLeft ] = useState<number>()
  // const [ balanceOf, setBalanceOf ] = useState<number>(0)
  const totalSupply = useContractRead({
    addressOrName: process.env.REACT_APP_ADDRESS || "",
    contractInterface: abi,
  }, 'totalSupply',
    {
      onError(error) {
        console.log("totalSupply read error")
      },
      onSuccess(result) {
        setSupplyLeft(result.toNumber())
      },
    }
  )

  // const balanceOfRead = useContractRead({
  //   addressOrName: process.env.REACT_APP_ADDRESS || "",
  //   contractInterface: abi,
  // }, 'balanceOf',
  //   {
  //     args: [account?.data?.address as string],
  //     onError(error) {
  //       console.log("balanceOfRead read error")
  //     },
  //   },
  // )


  useEffect(() => {
    if(totalSupply.data) {
      setSupplyLeft(parseInt(totalSupply.data as unknown as string))
  }

  }, [totalSupply.data])

  const {
    activeChain,
  } = useNetwork()
  const [total, setTotal] = useState(1);

  return (
    <Flex bgImage="./bg.png" bgSize={'cover'} height='100vh' flexDirection='column' justify='center'>
      <Flex justify='space-evenly' align='center' direction={width > 786 ? 'row' : 'column'} bgColor="#18151561" > 
        <Flex justify='space-evenly' align='center' direction='column' padding='10' borderRadius={'5px'} width={width > 1080 ? '25%' : '50%'}>
          <Image src="./monke.gif" borderRadius="15px 15px 15px 15px" />
          <Heading m={5} color="white">EthMonkeys</Heading>
          <Text fontSize={width > 1080 ? 'xl' : 'l'} fontWeight='bold' color='#fff' textAlign='center'>1 free mint then 0.005 each</Text>
          <Text fontSize={width > 1080 ? 'xl' : 'l'} fontWeight='bold' color='#fff' textAlign='center' marginBottom={5}>{supplyLeft}/5005</Text>

          <AccountButton />

        <Flex direction='row' marginTop={5} justify='center' align='center' width='100%'>
        <Button
        bg='#718096'
          onClick={() => total > 1 && setTotal(total - 1)}
        >
            -
        </Button>
        <Flex justify={'space-around'}>
          <Box padding='8px'  borderRadius='5px' bg='white' px={'5'} mx='5'>{total}</Box>
        </Flex>
        <Button
        bg='#718096'
          onClick={() => total < 25 && setTotal(total + 1)}
        >
            +
        </Button>
      </Flex >
          {activeChain?.id === 1 ? <MintButton amount={total}  /> : <Text color='yellow' p={5} m={5} borderRadius={5} textAlign='center'>Please make sure you are connected to mainnet</Text>}
      </Flex>
      
      <Toaster />
    </Flex>
    <Flex justify='center' align='center'>
    </Flex>
    </Flex>
  )
}